import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function JoinAuctionPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Sto aprendo il link invito…');

  useEffect(() => {
    if (!token) return;

    const join = async () => {
      try {
        const { data, error } = await supabase.rpc('join_auction_by_token', { p_token: token });
        if (error) throw error;
        navigate(`/auctions/${data}`, { replace: true });
      } catch (error: unknown) {
        setMessage(error instanceof Error ? error.message : 'Link non valido.');
      }
    };

    void join();
  }, [token, navigate]);

  return <main className="screen-center">{message}</main>;
}
